import React, { useCallback, useContext, useEffect, useState } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { RelativePathString, useRouter } from 'expo-router';
import { BasicScrollView } from "@/components/BasicScrollView";
import Head from 'expo-router/head';
import * as AppUtils from '@/utilities/AppUtils';
import { CustomText } from '@/components/CustomText';
import { CustomDivider } from "@/components/CustomDivider";
import { Button, Fieldset, Panel, Radio, Text } from 'react95-native-rabbl';
import * as AppConstants from '@/utilities/AppConstants';
import { AppContext } from '@/components/AppContext';
import * as AppUtilities from "@/utilities/AppUtilities";
import Footer from '@/components/Footer';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import { setLoggedIn } from '@/state/user';
import { setData } from '@/state/user';
import { CommunityMembership } from "@/types/community_membership";
import { Profile } from "@/types/profile";
import * as AppConsts from '@/utilities/AppConsts';
import { Meta } from '@/components/Meta';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    alignItems: 'center',
    backgroundColor: 'transparent',
    gap: 20,
  },
  contentWrapper: {
    padding: 20,
    gap: 20,
  },
});

export default function Join() {
  const domain = useSelector((state: RootState) => state.user.domain);
  const loggedIn = useSelector((state: RootState) => state.user.loggedIn);
  const community = useSelector((state: RootState) => state.user.current_community);
  const profiles = useSelector((state: RootState) => state.user.profiles);
  const [profile, setProfile] = useState<string>('');
  const { showSpinner, hideSpinner } = useContext(AppContext);
  const router = useRouter();
  const [processing, setProcessing] = useState(false);
  const dispatch = useDispatch();

  const onSubmit = useCallback(async () => {
    try {
      setProcessing(true);
      showSpinner();

      const response = await AppUtilities.fetchAuthorized(
        "Password.onSubmit",
        "/rabbl/api/set_community_profile",
        "POST",
        {
          domain: domain,
          profile_id: profile,
        }
      );
      const membership: CommunityMembership = ((response as any).body as any).community_membership;
      dispatch(setData(response));
      router.navigate(AppUtils.getProfileCreateNextPageLink(membership) as RelativePathString);

    } catch (e) {
      AppUtils.showErrorToast(AppUtilities.getErrors(e), () => onSubmit(), true);
      AppUtilities.handleException(e, "Join.onSubmit");
    } finally {
      setProcessing(false);
      hideSpinner();
    }
  }, [domain, profile]);

  return (
    <BasicScrollView center={true}>
      <Meta title={"Join"} />
      <Panel variant='raised' elevation={4}>
        <View style={AppConstants.STYLES.padding20gap10center}>
          <CustomText>Join {community.name}</CustomText>
          <View style={AppConstants.STYLES.padding2} />
          <CustomDivider fullWidth={true} />
          <View style={AppConstants.STYLES.padding2} />
          <Fieldset label='Profile' style={AppConstants.STYLES.gap20}>
            {profiles.map((p) => (
              <Radio
                key={p.profile_id.toString()}
                status={profile == p.profile_id.toString() ? 'checked' : 'unchecked'}
                onPress={() => setProfile(p.profile_id.toString())}
                label={p.name}
              />
            ))}
            <Radio
              status={profile == "-1" ? 'checked' : 'unchecked'}
              label='Create new profile'
              onPress={() => setProfile('-1')}
            />
          </Fieldset>
          <Button
            onPress={onSubmit}
            disabled={profile == ''}
          >Next</Button>
        </View>
      </Panel>
      <Footer />
    </BasicScrollView>
  );
}
